import { render, staticRenderFns } from "./TemplateCardCustomTokenDialog.vue?vue&type=template&id=cfc41012"
import script from "./TemplateCardCustomTokenDialog.vue?vue&type=script&lang=ts"
export * from "./TemplateCardCustomTokenDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports